import React, { Fragment, useEffect, useState } from 'react';
import {Card, ListGroup, CardSubtitle, CardTitle, CardText, ListGroupItem, CardBody, Row, Col, Table} from 'reactstrap';
//import Message from './Message';
import Progress from './Progress';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {listAll, delCert, openCert} from '../../actions/mymaster';

import Alert from '../layout/Alert';
import { clearProfile, getCurrentProfile, errhandle } from '../../actions/profile';
 

const FileUpload = ({ auth: {user}, 
  listAll, delCert, openCert , history, getCurrentProfile, errhandle,
  profile: {profile, allapplns, fnames, loadingall, profile2, gid} 
}) => {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  const navigate = useNavigate();


  // useEffect(() => {
  //   fnames = [];
  //   if(profile !== null && profile._aid !== undefined) {
  //     //console.log(profile._aid)
      
  //       listAll(profile._aid, gid); }          

  // }, [listAll, profile, gid]);  n

  // useEffect(() => {
  //   const formData = {};
  //   if(profile !== null && profile._aid !== undefined ) {
  //     formData.appId = profile._aid;    
  //     openCert(formData.appId, gid);
  //   }

  // }, [openCert, profile, gid]);

  
  
  const [file, setFile] = useState('');
  const [filename, setFilename] = useState('Choose Certificate');

  const [message, setMessage] = useState('');
  const [uploadPercentage, setUploadPercentage] = useState(0);

  var arrfiles = [];

  var certnames = [];
  certnames.push({key: 1, value: "RL"});
  
  
  function loadcerts() {
    console.log("invoking init " + loadingall);
    if(loadingall === true)
    {      
    }
  }

  const [cname, setcname] = useState(certnames[0].value);

  const onChange = (e,i) => {
          setFile(e.target.files[0]);
          setFilename(e.target.files[0].name);
          //console.log(filenames[i] + " " + e.target.files[0].name);
          fnames[i] = (e.target.files[0].name);
          console.log("in change file");
          console.log(fnames);
  };

  /*const onCertChange = e => {
    console.log(e.target.name + " " + e.target.value);
    setcname(e.target.value);    
  };*/

  const onBack = async e => {  
    var t = profile.e;
    await clearProfile();  
    //await getCurrentProfile(t);
    navigate('/dashboard');    
  };

  async function onList () {
     
          setMessage('');
          setFile('');
          const formData = {};

          
          if(profile !== null)
          {
              await listAll(profile._aid, gid);
              formData.appId = profile._aid;
              await openCert(formData.appId, gid);
          }    
  }

  
  const handleDeleteRow = async (e, i) => {
          e.preventDefault();
          console.log("deleting "+ i);

          const formData = {};
          formData.item = i.toString();

          if(profile !== null) {
              formData.appId = profile._aid;
              formData.gid = gid;
          }

            //console.log(formData);
            //await deleteCourse(formData);
            if(profile !== null)
              await delCert(formData);

            console.log("completed deleting");
            await onList();
  }

  const onUpd = async (e, cn, di) => {
          e.preventDefault();
          const formData = new FormData();
          formData.append('file', file);

          console.log(profile._aid);

          fnames[di] = '';
          
          if(file === '')
            alert("Select a file and upload");
          else {

          if(profile !== null) {
              formData.append('appId', profile._aid);
              formData.append('certname', "RL");
              formData.append('gid', gid);
              //formData.append('dbflag', dbflag);
          }

          console.log(formData);

          try {
            const res = await api.post('/upload/upload', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: progressEvent => {
                setUploadPercentage(
                  parseInt(
                    Math.round((progressEvent.loaded * 100) / progressEvent.total)
                  )
                );

                // Clear percentage
                setTimeout(() => setUploadPercentage(0), 10000);
              }
            });

            const { fileName, filePath } = res.data;

            //setUploadedFile({ fileName, filePath });

            console.log("uploaded " + fileName + " " + filePath);             

            await onList();
            await errhandle("File uploaded successfully", 1);
            navigate("/dashboard");
            
          } catch (err) {
            console.log("got you in catch");
            if (err.response && err.response.status.toString() === "400") {
              await errhandle(err.response.data.msg, 2);
              //setAlert(err.response.data.msg, 'danger');
            }
            if (err.response.status === 500) {
              setMessage('There was a problem with the server');
            } else {
              setMessage(err.response.data.msg);
            }
          } }

  }

  
  //var i = 0;

  return (
    <Fragment>
      
      {loadingall ? loadcerts() : null }

      <div className="profile" style={{textAlign: "center", paddingTop: "100px"}}>      
      <h2> Application ID: {profile && profile._aid} </h2>
      <h2> Name: {profile && profile._n}  </h2>
      </div>      
           
      
      <div className="mt-4">
      
          <>
          
          <Progress percentage={uploadPercentage} />

            <h5 className="" style={{ margin: "0px", textAlign: "center"}}> Kindly upload the following </h5>
             <h4 style={{textAlign: "center", color: "crimson"}}> (Maximum File Size: 1 MB) </h4> 
            <Alert />
            <div className="container" style={{paddingLeft: "10px", fontWeight: "bold"}}>        
            
            <Table bordered variant="dark" style={{color: "green", fontSize: "11pt"}} >
            <thead>
              
              <tr style={{color: "navy", fontWeight: "bold"}}>   
                <th scope="col"> Sl.No </th>             
                
                <th scope="col"> Certificate Name </th>                
                             

                <th scope = "col" > Saved File </th> 
                <th scope="col"> Select file and Click Save</th>  
                <th scope="col">  </th>
                <th scope="col"> Remove ? </th>
              </tr>
            </thead>
            <tbody>

          
          {certnames.map((cert, i) => (
            <tr key={i}>            
            <td> {i+1} </td>    
            
            <td> Request Letter with Proof </td>

            <td style={{color: "darkblue"}}> <a target="_blank" rel="noopener noreferrer"  
                  href = {allapplns && allapplns.filter(item => item.cn.includes(cert.value)).map(item => item.l)}> 
                  {profile2 && profile2.filter(item => item.Key.toString().includes(cert.value.toString())).map(item => item.Key)[0]} </a> <br/> {profile2 && profile2.filter(item => item.Key.toString().includes(cert.value.toString())).map(item => item.Size)[0] && <div> (Size: {Math.round(profile2 && profile2.filter(item => item.Key.toString().includes(cert.value.toString())).map(item => item.Size)[0]/1024)} KB)  </div> } </td>
            <td>
            <form>
                
                <div className='custom-file mb-4'>
                  <input
                    type='file'
                    className='custom-file-input'
                    style={{fontWeight: "bolder"}}
                    id='customFile'
                    onChange={(e) => onChange(e,i)}
                    
                  />
                  <label className='custom-file-label' htmlFor='customFile'>
                    {fnames[i]}
                  </label>
                </div>
                
            </form>
          </td>
          
          <td>                 
          <input
                  type='submit'
                  value='Save'
                  className='btn btn-primary'                  
                  onClick={(e) => onUpd(e,cert.value, i)  }
          />
          </td>
          <td> <button className="btn btn-danger" onClick={(e) => handleDeleteRow(e, profile2 && profile2.filter(item => cert.value === item.Key.split('/').pop().split('.').shift()).map(item => item.Key))} > delete </button> </td>

          </tr>   ) ) }

          </tbody>
          </Table>

          <Row className="my-3 but-center">
          <input type='submit' className='row btn btn-success' onClick={ e => onBack(e) } value="Go Back"/>
          </Row>
            
          </div>
        
        </>
      
        </div>

    </Fragment>
  );
};

FileUpload.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  listAll: PropTypes.func.isRequired,
  delCert: PropTypes.func.isRequired,
  openCert: PropTypes.func.isRequired,
  errhandle: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  { listAll, delCert, openCert, getCurrentProfile, errhandle }
)(FileUpload);